import { poweredByLogo } from 'assets/images';
import { useTranslation } from 'react-i18next';
import DabaduTooltip from 'sharedComponents/toolTip';

export const ServiceLogo = () => {
  const { t } = useTranslation();
  return (
    <div className='csc-screens__poweredby'>
      <span className=''>{t('stepperForm.poweredBy')}</span>
      <img src={poweredByLogo} alt='EquiFax' />
      <DabaduTooltip
        title='Equifax is a registered Canadian credit bureau that maintains your Canadian consumer credit file, which has been used here, as permitted by you, to provide you with educational content contained within your Equifax Consumer Credit Report. This is not your full Equifax Consumer Credit report. For a full copy of your up to date Equifax credit file, please contact Equifax  directly. The information contained herein is current as of the date indicated'
        placement='top-end'
        className='tooltip-wrapper'
      >
        <span>
          <span className='tooltip-wrapper__text'>!</span>
        </span>
      </DabaduTooltip>
    </div>
  );
};
